import 'jquery';

/**
* @param {object} o options
* @param {string} o.translations translations object, common.Close is needed
*/
export class Header {
    constructor(o) {
        o = typeof o !== 'undefined' ? o : {};
        this.translations = o.translations;

        if (typeof this.translations === 'undefined') {
            throw 'Header class called without property translations';
        }

        if (typeof this.translations.common.Close === 'undefined') {
            throw 'Contact class called without property translations.common.Close';
        }
    }

    updateIsATestEnvironmentLayout(isATestEnvironment) {
        if (isATestEnvironment) {
            $('.unify-sets-impersonation-and-test-layout').addClass('unify-is-a-test-environment');
        }
        else {
            $('.unify-sets-impersonation-and-test-layout').removeClass('unify-is-a-test-environment');
        }
    }

    updateIsAImpersonationLayout(user) {
        if (user.isImpersonated) {
            // add a class on the page wrapper to make it possible to show
            // that the curront logged in person is an impersonator setting css rule .TESTCLASS .SELECTOR
            $('.unify-sets-impersonation-and-test-layout').addClass('unify-is-a-impersonation');
        }
        else {
            $('.unify-sets-impersonation-and-test-layout').removeClass('unify-is-a-impersonation');
        }
    }

    updateTopBarWithUserInformation(user) {
        var loggedInNameInitials = '';
        if (typeof user !== "undefined") {
            var firstName = user !== null && typeof user.firstName !== "undefined" ? user.firstName : '';
            var lastName = user !== null && typeof user.lastName !== "undefined" ? user.lastName : '';
            loggedInNameInitials = firstName.charAt(0) + lastName.charAt(0);
        }
        var impersonatorClass = user !== null && typeof user !== 'undefined' && typeof user.isImpersonated !== "undefined" && user.isImpersonated === true ? ' class="impersonated"' : '';

        /*
        * stroke-width of circle is a indicator if it is impersonated
        */

        var loggedInSvg = '<svg xmlns="http://www.w3.org/2000/svg" height="40px" width="40px"' + impersonatorClass + ' viewbox="0 0 200 200">' +
            '<circle id="header-user-circle" cx="100" cy="100" r="90" stroke-width="10" />' +
            '<text x="50%" y="50%" text-anchor="middle" font-size="64px" fill="#fff" stroke="#fff" stroke-width="2px" dy=".3em">' + loggedInNameInitials + '</text>' +
            '</svg>';

        var userInformationHtml = '<span class="unify-header-user-wrapper">' + loggedInSvg + '</span>';

        if ($('.unify-header-user-wrapper').length > 0) {
            // already exist, remove that first
            $('.unify-header-user-wrapper').remove();
        }

        // add the new Username
        $('#right-drop').prepend(userInformationHtml);

        this.updateIsAImpersonationLayout(user);
    }

    /**
    * addTopBarRightUserLinks adds the top-menu links that exist in the right dropdown
    * @param {object} o optional parameters
    * @example
    *         append one option 'GOTO EMPTY PAGE' that links to './empty.html'
    *           addTopBarRightUserLinks({ append: true, objects: [ { name:'GOTO EMPTY PAGE', href:'./empty.html'} ] });
    *         append a seperator
    *           addTopBarRightUserLinks({ append: true, objects: [ { type:'seperator'} ] });
    *         append special html
    *           addTopBarRightUserLinks({ append: true, objects: [ { html:'<li><a href="#">blash</a></li>' } ] });
    */
    addTopBarRightUserLinks(o) {
        o = typeof o === 'undefined' ? {} : o;
        o.selector = typeof o.selector === 'undefined' ? '.dropdown-menu.unify-dropdown-user' : o.selector;

        // if passed with true in parameter append, append else replace content
        o.append = typeof o.append === 'undefined' ? false : o.append === true;

        var objectDefaultValues = [
            { href: '#', name: 'Logout' },
            { href: '#', name: 'Change password' }
        ];
        o.objects = typeof o.objects === 'undefined' ? objectDefaultValues : o.objects;

        var html = '';
        for (var i = 0, nr = o.objects.length; i < nr; i++) {
            var object = o.objects[i];
            if (typeof object.type !== 'undefined') {
                html += '<li role="separator" class="divider"></li>';
            }
            else if (typeof object.html !== 'undefined') {
                html += object.html;
            }
            else {
                html += '<li><a href="' + object.href + '">' + object.name + '</a></li>';
            }
        }
        if (o.append === false) {
            $(o.selector + ' li').remove();
        }
        $(o.selector).append(html);
    }

    /**
    * appendContactToTopHeader add contact menu option to option to header.
    * @param {Contact} contact a contact object
    */
    appendContactToHeader(contact) {
        //var contactInformation = contact.getContactInformation();
        this.appendModalToTopBarRightLinks('modal-contact', contact.title, contact.info);
    }

    /**
     * appendModalToTopBarRightLinks adds modal body that will be shown when user clicks the added option to the top bar links to the right.
     * The modal will contain given title and msg and the value shown in the option will be the title. 
     * @param {string} modalid the id of the modal to be created (mus be unique on the page)
     * @param {string} title the title on the modal and also the option name added to the top bar right links
     * @param {string} msg the message shown in the modal
     */
    appendModalToTopBarRightLinks(modalid, title, msg) {
        this.appendModalToBody(modalid, title, msg);
        this.addTopBarRightUserLinks({ append: true, objects: [{ html: '<li><a data-toggle="modal" data-target="#' + modalid + '">' + title + '</a></li>' }] });
    }

    /**
    * appendModalToBody adds a modal to the body tag with given modalid, title, message in given language.
    * @param {string} modalid the id of the modal to be created (mus be unique on the page)
    * @param {string} title the title on the modal and also the option name added to the top bar right links
    * @param {string} msg the message shown in the modal
    * @example
    *         append a Modal to the body in swedish language (determine the close button lang)
    *            appendModalToBody('test','title','msg');
    */
    appendModalToBody(modalid, title, msg) {
        if( $('#' + modalid).length !== 0 )  {
            return;
        }

        var modalHtml = '<!-- Modal -->' +
            '<div class="modal fade" id="' + modalid + '" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">' +
            '    <div class="modal-dialog" role="document">' +
            '        <div class="modal-content">' +
            '            <div class="modal-header">' +
            '                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>' +
            '                <h4 class="modal-title" id="myModalLabel">' + title + '</h4>' +
            '            </div>' +
            '            <div class="modal-body">' +
            msg +
            '            </div>' +
            '            <div class="modal-footer">' +
            '                <button type="button" class="btn btn-default" data-dismiss="modal">' + this.translations.common.Close + '</button>' +
            '            </div>' +
            '        </div>' +
            '    </div>' +
            '</div>';

        $('body').append(modalHtml);
    }
}